export default "__VITE_ASSET__0bd96817__"